import React, { useEffect, useCallback } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { useDropzone } from "react-dropzone";
import { v4 as uuidv4 } from "uuid";

export default function FileUpload(props) {
  const { setFieldValue, setFiles, files } = props;
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { "image/*": [], "application/pdf": [".pdf"] },
    onDrop: useCallback((acceptedFiles, rejectedFiles) => {
      if (acceptedFiles?.length) {
        setFiles((previousFiles) => [
          ...previousFiles,
          ...acceptedFiles.map((file) =>
            Object.assign(file, { preview: URL.createObjectURL(file), __id: uuidv4()})
          ),
        ]);
      }
    }, []),
  });

  useEffect(() => {
    setFieldValue("files", files);
  }, [files]);

  return (
    <Card
      sx={{
        border: "3px dashed #cbd5e0 ",
        backgroundColor: "#edf2f7",
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
      }}
      {...getRootProps()}
    >
      <CardContent>
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Suelte los archivos aquí ...</p>
        ) : (
          <p>
            Arrastre y suelte algunos archivos aquí, o haga clic para
            seleccionar archivos (Es obligatorio subir al menos un archivo *)
          </p>
        )}

        <Typography variant="body2">
          Archivos soportados
          <br />
          PDF, JPG, PNG
        </Typography>
      </CardContent>
    </Card>
  );
}
